
import createElementFromString from './create-element-from-string';

export default createElementFromString;
